<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ALLIED HEALTH SCIENCES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Optometry</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Science in Optometry</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Science in Optometry</b>
                    – The Bachelor of Science in Optometry (B.Sc. Optometry) offered by ARNI School of Allied Health
                    Sciences is a three-year undergraduate program designed to provide students with in-depth knowledge
                    and practical training in vision care, eye diseases, and the management of optical instruments. This
                    course aims to develop skilled optometrists capable of diagnosing vision problems, prescribing
                    corrective measures, and assisting in ocular surgeries.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Physiology (General)</li>
                    <li> Biochemistry (General & Ocular)</li>
                    <li> Community and Occupational Optometry</li>
                    <li> Basic Accountancy</li>
                    <li> Computer Basics</li>
                    <li> Anatomy (Practical)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> English and Communication</li>
                    <li> Biochemistry & Ocular Biochemistry</li>
                    <li> Optometry and Pediatric Optometry</li>
                    <li> Contact Lens</li>
                    <li> Environment & Ecology</li>
                    <li> Anatomy (Ocular)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Lighting & the Eye</li>
                    <li> Pharmacology</li>
                    <li> Ophthalmic & Optical Instrumentation & Procedure I</li>
                    <li> Geometrical Optics</li>
                    <li> Hospital Procedures</li>
                    <li> Microbiology & Pathology - Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Visual Optics</li>
                    <li> Ophthalmic & Optical Instrumentation & Procedure II</li>
                    <li> Ocular Disease I (Anterior Segment Disease)</li>
                    <li> Hospital Procedures</li>
                    <li> Low Vision Aids</li>
                    <li> Clinical Refraction Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b></p>
                <ul>
                    <li> Binocular Vision & Ocular Motality</li>
                    <li> Eye & Systemic Diseases</li>
                    <li> Optometric and Dispensing Optics</li>
                    <li> Pathology & Microbiology</li>
                    <li> Contact Lens -I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b></p>
                <ul>
                    <li> Binocular Vision & Ocular Motality
                    <li> Systemic Condition & the Eye</li>
                    <li> Public Health & Community Optometry</li>
                    <li> Professional Practice Management</li>
                    <li> Research Methodology and Statistics</li>
                    <li> Squint and Binocular Vision Practical</li>
                </ul>
            </div>

        </div>
    </div>
</section>
